export const routes = [
  {
    path: "bulk-upload",
    meta: { allowedRoles: ["prospect"] },
  },
];
